import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { InAppNotificationPreferencesEffects } from 'src/app/in-app-notifications/store/effects/in-app-notification-preferences.effects';
import { inAppNotificationPreferencesReducer } from 'src/app/in-app-notifications/store/reducers/in-app-notification-preferences.reducer';
import { inAppNotificationPreferencesFeatureKey } from 'src/app/in-app-notifications/store/selectors/in-app-notification-preferences.selectors';

export const provideInAppNotificationPreferencesStore = (): EnvironmentProviders[] => [
    provideState(inAppNotificationPreferencesFeatureKey, inAppNotificationPreferencesReducer),
    provideEffects([InAppNotificationPreferencesEffects])
];
